import { useEffect } from "react"
import PropTypes from "prop-types"
import { upperFirst } from "lodash"
import Card from "components/card"
import Profile from "./components/profile"
import Password from "./components/password"
import EmailSubscriptions from "modules/email-subscriptions"
import Mfa from "./components/mfa"
import Connections from "./components/connections"
import PersonalAccessTokens from "./components/personal-access-tokens"
import { useIsPatFeatureEnabled } from "resources/account"

import "./style.scss"

export default function UserProfile({
  id,
  name,
  email,
  profileErrors,
  passwordErrors,
  showEmailSubscriptions,
  update,
  authType,
  mfaSecret,
  qrCode,
  openDialog,
  mfaDevices,
  newMfaDevice,
  verifyMfaDevice,
  deleteMfaDevice,
  saveMfaDeviceName,
  resetMfa,
  newDeviceName,
  setNewDeviceName,
  mfaEnabled,
  checkAuthType,
  setAuthType,
}) {
  const isPatFeatureEnabled = useIsPatFeatureEnabled()

  // componentDidMount
  useEffect(() => {
    checkAuthType(email, setAuthType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const linkAccount = () => {
    const { pathname } = window.location
    window.location = `${authType.url}?origin=${pathname}`
  }

  return <div className="modules_user-profile">
    <Card title="My Profile" className="profile">
      <div className="content">
        <Profile {...{ name, email, profileErrors, update }} />
      </div>
    </Card>
    {authType.basicAuth && !authType.url
      && <Card title="Security" className="security">
        <div className="content">
          <Password {...{ passwordErrors, update, openDialog, mfaEnabled }} />
          <Mfa {...{ mfaSecret, qrCode, openDialog, mfaDevices, newMfaDevice, verifyMfaDevice, deleteMfaDevice, saveMfaDeviceName, resetMfa, newDeviceName, setNewDeviceName }} />
        </div>
      </Card>}
    {authType.basicAuth && authType.type && authType.url
      && <Card title="Link your account" className="password">
        <div className="content">
          <p>Your domain requires you link your account to {upperFirst(authType.type)}</p>
          <button className="btn btn-primary" type="submit" onClick={linkAccount}>
            Link account to {upperFirst(authType.type)}
          </button>
        </div>
      </Card>}
    {showEmailSubscriptions && <EmailSubscriptions userId={id} />}
    <Connections />
    {isPatFeatureEnabled && <PersonalAccessTokens />}
  </div>
}

UserProfile.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  profileErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
  passwordErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
  showEmailSubscriptions: PropTypes.bool.isRequired,
  update: PropTypes.func.isRequired,
  setAuthType: PropTypes.func.isRequired,
  checkAuthType: PropTypes.func.isRequired,
  location: PropTypes.object,
  authType: PropTypes.object,
  mfaSecret: PropTypes.string,
  verifyMfaDevice: PropTypes.func.isRequired,
  qrCode: PropTypes.string,
  openDialog: PropTypes.func.isRequired,
  mfaDevices: PropTypes.array.isRequired,
  newMfaDevice: PropTypes.func.isRequired,
  deleteMfaDevice: PropTypes.func.isRequired,
  saveMfaDeviceName: PropTypes.func.isRequired,
  resetMfa: PropTypes.func.isRequired,
  newDeviceName: PropTypes.string,
  setNewDeviceName: PropTypes.func.isRequired,
  mfaEnabled: PropTypes.bool.isRequired,
}
